import styles from '@/styles/hottest-deals/featuredDeals.module.scss'
import GoodsComponentWithDiscountNew from '@/components/GoodsComponentWithDiscountNew'
import { Button } from 'antd'

import SwiperSelf from '@/components/SwiperSelf'
import { SwiperSlide } from 'swiper/react';

interface ProductItem {
  productID: string;
  name: string;
  url: string;
  imgUrl: string;
  reviewCount: number;
  price: number;
  normalPrice: number;
  freeShipping: number;
  onSale: number;
  reduced: number;
  isNew: number;
  position?: number,
  location?: string;
  isEmailOnly: any,
  promotionTypeID: string | number;
  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    status: number;
    notified: number;
    pointRate: string;
    promotionRate: number;
  };
  review: {
    avgRank: number;
    total: number;
  };
}

interface TopSellersProps {
  featuredDealsData: ProductItem[][];
}

export default function FeaturedDeals(props: TopSellersProps) {
  return (
    <>
      <div className={styles['featured-deals-box']}>
        <div className={styles['title']}>BestDeals Featured Deals</div>

        {
          !!(props?.featuredDealsData && props.featuredDealsData.length) &&
          <SwiperSelf
            slidesPerView={1}
            pagination={true}
            loop={true} 
            autoplay={true} 
            delay={6000}
          >
            {
              props.featuredDealsData?.map((item: ProductItem[], index:number) => (
                <SwiperSlide key={index}>
                  <div className={styles['product-box']}>
                    {
                      item?.map((product: ProductItem, index:number) => (
                        <div className={styles['product-item']} key={index}>
                          <GoodsComponentWithDiscountNew {...{ ...product, productName: product.name, imgUrl: product.imgUrl }} />
                        </div>
                      ))
                    }
                  </div>
                </SwiperSlide>
              ))
            }
          </SwiperSelf>
        }

        <div className={styles['btn-box']}>
          <Button 
            href="/featured-deals"
            type="primary"
          >
            View All &gt;
          </Button>
        </div>
      </div>
    </>
  )
}